import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigureServiceAdComponent } from './configure-service-ad.component';
import { CoreModule } from '@dm/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ConfigureDnsModule } from 'app/feature/service/v-store-service/v-store/detail-v-store/detail-service/dns/configure-dns/configure-dns.module';

@NgModule({
    declarations: [ConfigureServiceAdComponent],
    exports: [ConfigureServiceAdComponent],
    imports: [
        CommonModule,
        CoreModule,
        ReactiveFormsModule,
        ConfigureDnsModule,
    ],
})
export class ConfigureServiceAdModule { }
